import { globalURL, fetchApiHeaders } from "../../app/constants/constants";
import { checkFormFields } from "../../app/helpers/functions";

const toggleModal = (show, process) => dispatch => {
    dispatch({
        type: "TOGGLE_CUSTOMERCOMMENT_MODAL",
        payload: {
            show: show,
            process: process
        }
    })
    if (!show) {
        dispatch({
            type: "SET_TABLE_ROW_DATA",
            payload: {
                row: null,
                rowIndex: 0
            }
        })
    }
}

const setValue = (key, value) => dispatch => {
    dispatch({
        type: "SET_VALUE_CUSTOMERCOMMENT",
        payload: {
            key: key,
            value: value
        }
    })
}

const getAll = (token) => dispatch => {
    dispatch({
        type: "GET_ALL_CUSTOMERCOMMENTS"
    })
    fetch(globalURL + "/customerComment/getAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        }
    })
        .then((result) => result.json())
        .then(async (customerComments) => {
            if (customerComments.success) {
                dispatch({
                    type: "FETCH_ALL_CUSTOMERCOMMENTS",
                    payload: customerComments.data
                })
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_ALL_CUSTOMERCOMMENTS",
                    payload: customerComments
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });

            dispatch({
                type: "ERROR_ALL_CUSTOMERCOMMENTS",
                payload: error
            })
        })
}

const createNew = (token, data) => dispatch => {
    dispatch({
        type: "GET_INSERT_CUSTOMERCOMMENTS"
    })

    var checkForm = checkFormFields(data, false);
    if (!checkForm.result) {
        fetch(globalURL + "/customerComment/create", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                name: data[0].value,
                surname: data[1].value,
                title: data[2].value,
                company: data[3].value,
                point: data[4].value,
                commentText: data[5].value,
                image: data[6].value,
            })
        })
            .then((result) => result.json())
            .then(async (insert) => {
                console.log(insert)
                if (insert.success) {
                    dispatch({
                        type: "FETCH_INSERT_CUSTOMERCOMMENTS",
                        payload: insert
                    });
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: data[0].value + " rengi başarıyla oluşturuldu",
                            type: "success"
                        }
                    });
                } else {
                    if (insert.field) {
                        dispatch({
                            type: "SET_VALUE_ERROR_CUSTOMERCOMMENT",
                            payload: {
                                key: insert.field,
                                helpertext: insert.errorMessage
                            }
                        })
                    } else {
                        dispatch({
                            type: "TOGGLE_APP_ALERT",
                            payload: {
                                show: true,
                                message: "İşlem gerçekleştirilirken bir hata oluştu.",
                                type: "error"
                            }
                        })
                    }
                    dispatch({
                        type: "ERROR_INSERT_CUSTOMERCOMMENTS",
                        payload: insert
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                })
                dispatch({
                    type: "ERROR_INSERT_CUSTOMERCOMMENTS",
                    payload: error
                })
            })
    } else {
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_CUSTOMERCOMMENT",
                payload: {
                    ...item,
                    helpertext: "Bu Alan Zorunludur"
                }
            })
        })
    }
}

const tableActions = (process, id, token) => dispatch => {
    if (process === "update") {
        dispatch({
            type: "GET_DETAIL_CUSTOMERCOMMENT"
        })
        fetch(globalURL + "/customerComment/getDetail", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                id: id
            })
        })
            .then((result) => result.json())
            .then(async (detail) => {
                if (detail.success) {
                    dispatch({
                        type: "FETCH_DETAIL_CUSTOMERCOMMENT",
                        payload: detail
                    })
                    dispatch({
                        type: "TOGGLE_CUSTOMERCOMMENT_MODAL",
                        payload: {
                            show: true,
                            process: process
                        }
                    })
                } else {
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: "İşlem gerçekleştirilirken bir hata oluştu.",
                            type: "error"
                        }
                    });

                    dispatch({
                        type: "ERROR_DETAIL_CUSTOMERCOMMENT",
                        payload: detail
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_DETAIL_CUSTOMERCOMMENT",
                    payload: error
                })
            })
    } else {
        dispatch({
            type: "TOGGLE_CUSTOMERCOMMENT_MODAL",
            payload: {
                show: true,
                process: process
            }
        })
    }
}

const update = (token, id, data, rowIndex) => dispatch => {
    dispatch({
        type: "GET_UPDATE_CUSTOMERCOMMENT"
    });

    var checkForm = checkFormFields(data, false);
    if (!checkForm.result) {
        // update
        fetch(globalURL + "/customerComment/update", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                id: id,
                name: data[0].value,
                surname: data[1].value,
                title: data[2].value,
                company: data[3].value,
                point: data[4].value,
                commentText: data[5].value,
                image: data[6].value,
            })
        })
            .then((result) => result.json())
            .then(async (update) => {
                if (update.success) {
                    dispatch({
                        type: "FETCH_UPDATE_CUSTOMERCOMMENT",
                        payload: update,
                        rowIndex: rowIndex
                    });

                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: data[0].value + " kullanıcı yorumu başarıyla güncellendi.",
                            type: "success"
                        }
                    });
                } else {
                    if (update.field) {
                        dispatch({
                            type: "SET_VALUE_ERROR_CUSTOMERCOMMENT",
                            payload: {
                                key: update.field,
                                helpertext: update.errorMessage
                            }
                        })
                    } else {
                        dispatch({
                            type: "TOGGLE_APP_ALERT",
                            payload: {
                                show: true,
                                message: "İşlem gerçekleştirilirken bir hata oluştu.",
                                type: "error"
                            }
                        });
                    }
                    dispatch({
                        type: "ERROR_UPDATE_CUSTOMERCOMMENT",
                        payload: update
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_UPDATE_CUSTOMERCOMMENT",
                    payload: error
                })
            })

    } else {
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_CUSTOMERCOMMENT",
                payload: {
                    ...item,
                    helpertext: "Bu Alan Zorunludur"
                }
            })
        })
    }
}

const deleteEntity = (token, row, rowIndex) => dispatch => {
    dispatch({
        type: "GET_DELETE_CUSTOMERCOMMENT"
    })
    fetch(globalURL + "/customerComment/delete", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            id: row.id,
            name: row.name,
            surname: row.surname
        })
    })
        .then((result) => result.json())
        .then(async (deleteRecord) => {
            if (deleteRecord.success) {
                dispatch({
                    type: "FETCH_DELETE_CUSTOMERCOMMENT",
                    payload: deleteRecord,
                    rowIndex: rowIndex
                });

                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem başarıyla gerçekleşti.",
                        type: "success"
                    }
                });
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_DELETE_CUSTOMERCOMMENT",
                    payload: deleteRecord
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });
            dispatch({
                type: "ERROR_DELETE_CUSTOMERCOMMENT",
                payload: error
            })
        })
}



export {
    toggleModal,
    setValue,
    getAll,
    createNew,
    update,
    tableActions,
    deleteEntity
}